export default __webpack_public_path__ + "static/media/linkedin.e4223106.svg";